import React, { Component } from "react";
import SearchResultRow from "./SearchResultRow";

export default class SearchResults extends Component {
  render() {
    const rows = [];

    this.props.searchResults.organizations.forEach(anOrg => {
      rows.push(<SearchResultRow org={anOrg} key={anOrg.organizationId} />);
    });

    return (
      <table class="table table-hover table-responsive table-condensed">
        <thead>
          <tr>
            <th>Search results for <b>{this.props.searchText}</b></th>
          </tr>
          <tr>
            <th>Org Name</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/firstnet/search/organization/components/SearchResults.js